export const engineiusMenu = [
  { label: 'Home', icon: '', routerLink: ['/app'] },
  { label: 'Driver Map BETA', icon: '', routerLink: ['/app/driver-location-view'] },
  { label: 'Jobs Inbox', icon: '', routerLink: ['/app/vmeinbox'] },
  { label: 'Routes Inbox', icon: '', routerLink: ['/app/routes-inbox'] },
  {
    label: 'Supplier Availability',
    icon: '',
    routerLink: ['/app/supplier-availability-dashboard'],
  },
  { label: 'Supplier Schedule', icon: '', routerLink: ['/app/supplier-schedule-view'] },
  { label: 'Planning Tool', icon: '', routerLink: ['/app/supplier-schedule-planning-tool'] },
  { label: 'Supplier Feedback', icon: '', routerLink: ['/app/supplierFeedback'] },
  { label: 'Incident Management', icon: '', routerLink: ['/app/incidents'] },
  { label: 'Supplier Risk Management', icon: '', routerLink: ['/app/supplier-risk-management'] },
  {
    label: 'Order Booking Health Check',
    icon: '',
    routerLink: ['/app/order-booking-health-check'],
  },
  {
    label: 'Customer Order Limits',
    icon: '',
    routerLink: ['/app/order-limits-admin'],
  },
  {
    label: 'Interactions',
    icon: '',
    items: [
      { label: 'All Interactions', icon: '', routerLink: ['/app/interactions'] },
      { label: 'Interactions Report', icon: '', routerLink: ['/app/interactions-report'] },
    ],
  },
  {
    label: 'Administration',
    icon: '',
    items: [
      {
        label: 'Additional Cost Questions',
        icon: '',
        routerLink: ['/app/additional-cost-questions'],
      },
      {
        label: 'Amazon Inspection',
        icon: '',
        routerLink: ['/app/amazon-inspection'],
      },
      { label: 'Banner Management', icon: '', routerLink: ['/app/banner-management'] },
      { label: 'Checklist Fees', icon: '', routerLink: ['/app/checklist-fees'] },
      {
        label: 'Cost Rejection Reasons',
        icon: '',
        routerLink: ['/app/cost-rejection-reasons'],
      },
      { label: 'Create Tags', icon: '', routerLink: ['/app/tagging-admin'] },
      { label: 'Customer Priority', icon: '', routerLink: ['/app/customer-priority'] },
      { label: 'Delay-Failure Admin', icon: '', routerLink: ['/app/delay-failure-admin'] },
      {
        label: 'Delay Failure Templates',
        icon: '',
        routerLink: ['/app/delay-failure-templates'],
      },
      {
        label: 'Driver Checklist Admin',
        icon: '',
        routerLink: ['/app/customers/driverchecklistadmin'],
      },
      {
        label: 'Driver Referral Link Admin',
        icon: '',
        routerLink: ['/app/driver-referral-link-admin'],
      },
      { label: 'Email Templates', icon: '', routerLink: ['/app/email-templates'] },
      { label: 'Incident Admin', icon: '', routerLink: ['/app/incident-admin'] },
      { label: 'Incident Closure', icon: '', routerLink: ['/app/incident-closure-admin'] },
      {
        label: 'Interaction Categories',
        icon: '',
        routerLink: ['/app/interaction-category-admin'],
      },
      { label: 'Invoices', icon: '', routerLink: ['/app/invoices'] },
      { label: 'Invoice Addresses', icon: '', routerLink: ['/app/invoiceaddresses'] },
      {
        label: 'Job Rejection Reasons',
        icon: '',
        routerLink: ['/app/job-rejection-reasons'],
      },
      { label: 'Operational Areas', icon: '', routerLink: ['/app/eareas'] },
      { label: 'Operational Regions', icon: '', routerLink: ['/app/eregions'] },
      {
        label: 'Order Creation Notification',
        icon: '',
        routerLink: ['/app/order-creation-notification-admin'],
      },
      {
        label: 'Order Booking Health Check',
        icon: '',
        routerLink: ['/app/order-booking-check-configuration'],
      },
      {
        label: 'Route Algo',
        icon: '',
        routerLink: ['/app/route-algo-admin'],
      },
      { label: 'Service Delivery Groups', icon: '', routerLink: ['/app/service-delivery-groups'] },
      { label: 'Supplier Tagging', icon: '', routerLink: ['/app/supplier-tagging'] },
      { label: 'VAT Rates', icon: '', routerLink: ['/app/vatrates'] },
    ],
  },
  {
    label: 'Telephony',
    icon: '',
    items: [
      { label: 'Number Assigment', icon: '', routerLink: ['/app/telephone-number-admin'] },
      { label: 'User Management', icon: '', routerLink: ['/app/telephony-users'] },
      { label: 'Webhook Management', icon: '', routerLink: ['/app/telephony-webhooks'] },
    ],
  },
  {
    label: 'Manage Accounts ',
    icon: '',
    items: [
      { label: 'User Registration Requests', icon: '', routerLink: ['/app/userrequests'] },
      { label: 'Engineius Accounts', icon: '', routerLink: ['/app/engineius-users'] },
      { label: 'Organisations', icon: '', routerLink: ['/app/organisations'] },
      {
        label: 'Organisation Custom Settings',
        icon: '',
        routerLink: ['/app/organisation-custom-settings'],
      },
      {
        label: 'Organisation Task Types',
        icon: '',
        routerLink: ['/app/organisation-task-types'],
      },
      { label: 'Customer Steps & Photos', icon: '', routerLink: ['/app/customers/photos'] },
    ],
  },
  {
    label: 'Agreements',
    icon: '',
    items: [
      {
        label: 'Generic Agreement',
        icon: '',
        items: [
          { label: 'Customer', icon: '', routerLink: ['/app/agreement/gc'] },
          { label: 'Supplier', icon: '', routerLink: ['/app/agreement/gs'] },
        ],
      },
      {
        label: 'Bespoke Agreement',
        icon: '',
        items: [
          { label: 'Customer', icon: '', routerLink: ['/app/bespokeagreements/c'] },
          { label: 'Supplier', icon: '', routerLink: ['/app/bespokeagreements/s'] },
        ],
      },
      { label: 'Self-Billing Agreements', icon: '', routerLink: ['/app/selfbilling'] },
      { label: 'Terms & Conditions', icon: '', routerLink: ['/app/termsconditionslist'] },
      { label: 'Trade Plates', icon: '', routerLink: ['/app/trade-plates'] },
      {
        label: 'Rate Card Presets',
        icon: '',
        routerLink: ['/app/ratecard-admin'],
      },
      { label: 'Fuel Price Adjuster', icon: '', routerLink: ['/app/fuel-price-adjuster'] },
    ],
  },
  {
    label: 'Reporting',
    icon: '',
    items: [
      { label: 'Tasks', icon: '', routerLink: ['/app/report/tasks'] },
      //{ label: 'Orders', icon: '', routerLink: ['/app/report/orders'] },
      //{ label: 'Disputes', icon: '', routerLink: ['/app/report/disputes'] },
      { label: 'Supplier Feedback', icon: '', routerLink: ['/app/report/supplierFeedback'] },
      { label: 'Jobs', icon: '', routerLink: ['/app/report/jobs'] },
      { label: 'Organisations', icon: '', routerLink: ['/app/report/organisations'] },
      { label: 'Order Cancellation', icon: '', routerLink: ['/app/report/ordercancellation'] },
      {
        label: 'Supplier Unassignment',
        icon: '',
        routerLink: ['/app/report/supplierUnassignment'],
      },
      { label: 'Job Cancellation', icon: '', routerLink: ['/app/report/jobcancellation'] },
      { label: 'Transaction Lines', icon: '', routerLink: ['/app/report/transactionlines'] },
      {
        label: 'Non-Movement Transactions',
        icon: '',
        routerLink: ['/app/report/non-movement-transactions'],
      },
      { label: 'Order Dump', icon: '', routerLink: ['/app/orderdump'] },
      { label: 'User Management', icon: '', routerLink: ['/app/user-management-report'] },
      {
        label: 'Expenses',
        icon: '',
        routerLink: ['/app/report/declined-expenses-report'],
      },
    ],
  },
  {
    label: 'System Admin',
    icon: '',
    items: [
      { label: 'AutoDirect', icon: '', routerLink: ['/app/auto-direct'] },
      { label: 'Checklist Categories', icon: '', routerLink: ['/app/checklist-categories'] },
      { label: 'Checklist Steps', icon: '', routerLink: ['/app/checklist-steps'] },
      { label: 'Comms Templates', icon: '', routerLink: ['/app/comms-maintenance'] },
      { label: 'Cancellation Statuses', icon: '', routerLink: ['/app/cancellation-statuses'] },
      {
        label: 'Customer Additional Charge',
        icon: '',
        routerLink: ['/app/organisation-additional-charge-types'],
      },
      { label: 'Discount Codes', icon: '', routerLink: ['/app/manage-b2c-discount'] },
      { label: 'Discount Lookup', icon: '', routerLink: ['/app/manage-discount-lookup'] },
      { label: 'B2C Discount', icon: '', routerLink: ['/app/b2c-discount'] },
      { label: 'Handover Times', icon: '', routerLink: ['/app/handover-times'] },
      { label: 'Insurance Providers', icon: '', routerLink: ['/app/insurance-providers'] },
      { label: 'Job Alert Defaults', icon: '', routerLink: ['/app/job-alert-settings-admin'] },
      { label: 'Job Deployment Priority', icon: '', routerLink: ['/app/job-deployment-priority'] },
      { label: 'Job Hold Configuration', icon: '', routerLink: ['/app/job-hold-configuration'] },
      { label: 'Job Match Settings', icon: '', routerLink: ['/app/auto-job-match-settings'] },
      { label: 'Job Unassigned Reasons', icon: '', routerLink: ['/app/job-unassigned-reasons'] },
      {
        label: 'Long Distance Time Bands',
        icon: '',
        routerLink: ['/app/manage-long-distance-time-bands'],
      },
      { label: 'Mobile Logging', icon: '', routerLink: ['/app/mobile-logging'] },
      {
        label: 'Non-Movement Descriptions',
        icon: '',
        routerLink: ['/app/non-movement-descriptions'],
      },
      { label: 'Postcode Weighting', icon: '', routerLink: ['/app/manage-weight'] },
      { label: 'Service Type On Hold', icon: '', routerLink: ['/app/task-types-on-hold'] },
      {
        label: 'Supplier Deactivation Admin',
        icon: '',
        routerLink: ['/app/supplier-deactivation-admin'],
      },
      {
        label: 'Customer User Deactivation Admin',
        icon: '',
        routerLink: ['/app/customer-user-deactivation-admin'],
      },
      { label: 'System Configuration', icon: '', routerLink: ['/app/settings'] },
      {
        label: 'Task Level Report Settings',
        icon: '',
        routerLink: ['/app/customer-invoice-report'],
      },
    ],
  },
  //{ label: "Dashboard Summary", icon: "", routerLink: ["/app/dashboard-summary"] },
];
